import { useMemo } from 'react'
import { useGetTooltipsQuery } from '../store/settings/hooks'

/**
 * Returns a stable `resolve` function that looks up the `TooltipDescription`
 * for a given `ToolTipID` from the ToolTipList (DSCATooltipMetadataList).
 *
 * Data is fetched via RTK Query.
 * Calling this hook from any component automatically triggers the fetch.
 *
 * Returns empty string if the ID is not found — no tooltip icon is rendered.
 *
 * @example
 * const resolve = useTooltipResolver()
 * <RhyBusInputText info={resolve(TT_FORM_TITLE)} ... />
 */
export function useTooltipResolver(): (id: string) => string {
    const { data: tooltips } = useGetTooltipsQuery()

    const lookupMap = useMemo<Record<string, string>>(() => {
        const map: Record<string, string> = {}
        tooltips?.forEach((item: any) => {
            const id = item?.TooltipID
            const desc = item?.TooltipDescription
            if (id && desc) {
                map[id] = desc
            }
        })
        return map
    }, [tooltips])

    return useMemo(
        () => (id: string): string => lookupMap[id] ?? '',
        [lookupMap]
    )
}
